import { api } from 'api/api';
import { AppointmentResponseViewModel } from 'types/appointment';
import {
    GetAppointmentsRequest,
    UpdateAppointmentRequest,
    AppointmentsResponse,
    CreateAppointmentRequest,
    CreateAppointmentConfirmationRequest,
} from './types';
import { parametrizeURL } from 'api/utils';

export const APPOINTMENT_URL = 'Appointment' as const;
export const GET_APPOINTMENTS_URL = `${APPOINTMENT_URL}/GetAllAsync` as const;
export const ADD_APPOINTMENT_URL = `${APPOINTMENT_URL}/AddAsync` as const;
export const UPDATE_APPOINTMENT_URL = `${APPOINTMENT_URL}/UpdateAsync/{appointmentId}` as const;
export const UPDATE_APPOINTMENT_CONFIRMATION_URL =
    `${APPOINTMENT_URL}/SetContractorConfirmedDateTimeAsync/{appointmentId}` as const;

export const readAppointmentById = (params: { id: string }) =>
    api.get<AppointmentResponseViewModel>(APPOINTMENT_URL, { params });

export const deleteAppointmentById = (data: { id: string }) => api.delete<void>(APPOINTMENT_URL, { data });

export const readAppointments = (params?: GetAppointmentsRequest) =>
    api.get<AppointmentsResponse>(GET_APPOINTMENTS_URL, { params });

export const createAppointment = (body: CreateAppointmentRequest) =>
    api.post<AppointmentResponseViewModel>(ADD_APPOINTMENT_URL, body);

export const createAppointmentConfirmation = (appointmentId: string, body: CreateAppointmentConfirmationRequest) =>
    api.post<AppointmentResponseViewModel>(
        parametrizeURL(UPDATE_APPOINTMENT_CONFIRMATION_URL, { appointmentId }),
        body,
    );

export const replaceAppointment = (appointmentId: string, body: UpdateAppointmentRequest) =>
    api.post<AppointmentResponseViewModel>(parametrizeURL(UPDATE_APPOINTMENT_URL, { appointmentId }), body);
